export {default} from './PremierVolumeSection.connect';
